var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPriceMeThreeDots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 41,
    viewBox: "0 0 35 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 41,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2_218",
    transform: "matrix(0.0111111 0 0 0.00948509 0 0.0731707)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2_218",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB0klEQVR4nO3aO07DQBSF4WwFCejxPeNUUJCwj8zgRfHaCq9NAHtAREKhDzIPQUVwjO/Y5P+kadLE98SyJ6MzGgEAAAAAAMCV2fGRlM7N4oOUXj7WvVk8k+KUn6OlEKpds3grpeVPyyzdjMezHQJfQwjpQIrzVSF/rTgvitn+Ot+10XeyGoX8eWfHp7294+3c1z8YUrxqGvK3sG9zX/+QXnzLNiuENMk9R+9J6aJt0GbpNPccvWfvW7hWQddbv9xz9J4UF+2Djovcc2xE0GbpOfccG/LoiHe55+g9KZ3/QdAnuefoPSlO2wZdFLPD3HMMgpQuWzyfb3Jf/2CUZbUlxcfmIfMXvLH6gKgOrknIHCqtqT76lOL1L15+Vxwm/YEQ0qT+W11v29732W/rrv6MFx8AAMDgGL2ObgV6Hd0L9Do8Qq7odXgQvY7uGb0OH6LX4cPodfgQvY7hBG30Olaj1+FE9Dq8go70OryIXoePkl6Hn4Jeh58xvQ5fgV4HAADAf2L0OroV6HV0L9Dr8Ai5otfhQfQ6umf0OnyIXocPo9fhQ/Q6hhO00etYjV6HE9Hr8Ao60uvwInodPkp6HX4Keh1+xvQ6fAV6HQAAAAAAAKM+eQWf0IBRgPPOoAAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceMeThreeDots);
export default __webpack_public_path__ + "static/media/price-me-three-dots.fdada217b3438994852ffa101cc8e84b.svg";
export { ForwardRef as ReactComponent };